import { ReactNode, Ref, useId } from 'react';
import { Flex } from 'antd';
import { Text } from '../Ant';
import { ChevronDown } from '../icons';
import { DateGroupHeader } from '../../assets/styles/components/dashboard.styled';

interface ICollapsibleDateGroupProps {
  title: string;
  itemCount?: string;
  total?: string;
  collapsed: boolean;
  onToggle: () => void;
  children: ReactNode;
  className?: string;
  ref?: Ref<HTMLDivElement>;
  'data-testid'?: string;
}

const CollapsibleDateGroup = ({
  title,
  itemCount,
  total,
  collapsed,
  onToggle,
  children,
  className = '',
  ref,
  'data-testid': testId = 'date-group',
}: ICollapsibleDateGroupProps) => {
  const contentId = useId();
  return (
    <Flex vertical ref={ref} className={`w-full gap-date-group ${className}`} data-testid={testId}>
      <DateGroupHeader
        type="button"
        aria-expanded={!collapsed}
        aria-controls={collapsed ? undefined : contentId}
        onClick={onToggle}
        data-testid="date-group-header"
      >
        <ChevronDown className="date-group-chevron" />
        <Text
          $fontsize="13px"
          $lineheight="20px"
          $color="primary"
          $weight={600}
          className="date-group-title"
          data-testid="date"
        >
          {title}
        </Text>
        {itemCount && (
          <Text
            $fontsize="12px"
            $lineheight="18px"
            $color="description"
            className="date-group-count"
            data-testid="date-group-count"
          >
            {itemCount}
          </Text>
        )}
        {total && (
          <Text
            $fontsize="13px"
            $lineheight="20px"
            $color="primary"
            $weight={600}
            className="date-group-total"
            data-testid="total-billable"
          >
            {total}
          </Text>
        )}
      </DateGroupHeader>
      {!collapsed && (
        // display: contents lets the cards share the group's own gap.
        <div id={contentId} className="d-contents">
          {children}
        </div>
      )}
    </Flex>
  );
};

export default CollapsibleDateGroup;
